<template>
    <div class="results-impacts-form1">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <div class="lock-message">
            <LockPP :statusLock="0" />

            <div class="text">
                Caso queira que suas informações não sejam públicas, clique no icone do cadeado para ocultar.
            </div>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="Processos de monitoramento e avaliações sistematizadas"
                label-for="hasMonitoringProcess"
                class="required"
            >
                <b-form-radio-group
                    id="hasMonitoringProcess"
                    name="hasMonitoringProcess"
                    v-model="$v.form.hasMonitoringProcess.selected.$model"
                    :options="form.hasMonitoringProcess.options"
                    :state="validateState('hasMonitoringProcess')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['processo_monitoramento'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['processo_monitoramento'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasMonitoringProcess')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="A iniciativa possui indicadores de desempenho?"
                label-for="hasPerformanceIndications"
                class="required"
            >
                <b-form-radio-group
                    id="hasPerformanceIndications"
                    name="hasPerformanceIndications"
                    v-model="$v.form.hasPerformanceIndications.selected.$model"
                    :options="form.hasPerformanceIndications.options"
                    :state="validateState('hasPerformanceIndications')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['indicadores_desempenho'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['indicadores_desempenho'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasPerformanceIndications')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Liste os indicadores de impacto utilizados pela sua iniciativa?"
                label-for="indicatorsList"
                v-if="Number(form.hasPerformanceIndications.selected) === 1"
            >
                <b-form-textarea
                    id="indicatorsList"
                    name="indicatorsList"
                    v-model="form.indicatorsList"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['indicadores_impacto'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['indicadores_impacto'].value"
                />
            </b-form-group>

            <b-form-group>
                <label class="required">
                    Número de pessoas impactadas direta ou indiretamente pela iniciativa
                </label>

                <div class="row">
                    <div class="col-md-6">
                        <label for="directly">Diretamente:</label>

                        <b-form-input
                            id="directly"
                            v-model="$v.form.directly.$model"
                            type="number"
                            placeholder="Digite aqui"
                            min="0"
                            :state="validateState('directly')"
                            :disabled="getIsDisabled"
                            v-if="
                                !isPlatform ||
                                    (isPlatform &&
                                        getAuthorizationData &&
                                        getAuthorizationData['pessoas_impactadas_dir'].value)
                            "
                        ></b-form-input>

                        <NoAuthorizationMsgPP
                            v-if="
                                isPlatform &&
                                    getAuthorizationData &&
                                    !getAuthorizationData['pessoas_impactadas_dir'].value
                            "
                        />

                        <b-form-invalid-feedback :state="validateState('directly')">
                            Digite um número válido
                        </b-form-invalid-feedback>
                    </div>

                    <div class="col-md-6">
                        <label for="indirectly">Indiretamente:</label>

                        <b-form-input
                            id="indirectly"
                            v-model="$v.form.indirectly.$model"
                            type="number"
                            placeholder="Digite aqui"
                            min="0"
                            :state="validateState('indirectly')"
                            :disabled="getIsDisabled"
                            v-if="
                                !isPlatform ||
                                    (isPlatform &&
                                        getAuthorizationData &&
                                        getAuthorizationData['pessoas_impactadas_ind'].value)
                            "
                        ></b-form-input>

                        <NoAuthorizationMsgPP
                            v-if="
                                isPlatform &&
                                    getAuthorizationData &&
                                    !getAuthorizationData['pessoas_impactadas_ind'].value
                            "
                        />

                        <b-form-invalid-feedback :state="validateState('indirectly')">
                            Digite um número válido
                        </b-form-invalid-feedback>
                    </div>
                </div>

                <h6>Nos conhecendo melhor</h6>

                <div>
                    Compartilhe conosco três ações que você realizou onde acredita que alcançou seu propósito (insira
                    fotos, vídeos, links)
                </div>

                <b-form-group label="Ação 1" label-for="action1">
                    <b-form-select
                        id="action1"
                        name="action1"
                        v-model="form.action1.selected"
                        :options="form.action1.options"
                        :disabled="getIsDisabled"
                    ></b-form-select>

                    <LockPP
                        :statusLock="form.action1Lock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.action1Lock = Number(!form.action1Lock)"
                        v-if="showLock"
                    />
                </b-form-group>

                <FormFilePP
                    ref="action1Ref"
                    :text1="textFile1"
                    :text2="textFile2"
                    :disabled="getIsDisabled"
                    :singleFile="true"
                    :previewImg="true"
                    :singleFileData="singleFileData1"
                    :urlSingleFileData="urlSingleFileData1"
                    :showSingleFile="!receiveData"
                    @removeSingleFile="removeSingleFile1"
                    v-if="form.action1.selected === 1"
                ></FormFilePP>

                <b-form-group label="Link" label-for="linkAction1" v-if="form.action1.selected === 2">
                    <b-form-input
                        name="linkAction1"
                        v-model="form.linkAction1"
                        placeholder="Link aqui"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['acao1_url'].value)
                        "
                    ></b-form-input>

                    <div
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['acao1_url'].value)
                        "
                    >
                        <iframe
                            width="100%"
                            height="315"
                            :src="convertYoutubeLink(form.linkAction1)"
                            v-if="
                                form.action1.selected === 2 &&
                                    form.linkAction1 !== null &&
                                    isYoutubeLink(form.linkAction1)
                            "
                        ></iframe>
                    </div>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['acao1_url'].value"
                    />
                </b-form-group>

                <b-form-group label="Descrição da ação" label-for="descriptionAction1">
                    <b-form-input
                        name="descriptionAction1"
                        v-model="form.descriptionAction1"
                        placeholder="Descreva aqui"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['acao1_descricao'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['acao1_descricao'].value"
                    />
                </b-form-group>

                <b-form-group label="Ação 2" label-for="action2">
                    <b-form-select
                        id="action2"
                        name="action2"
                        v-model="form.action2.selected"
                        :options="form.action2.options"
                        :disabled="getIsDisabled"
                    ></b-form-select>

                    <LockPP
                        :statusLock="form.action2Lock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.action2Lock = Number(!form.action2Lock)"
                        v-if="showLock"
                    />
                </b-form-group>

                <FormFilePP
                    ref="action2Ref"
                    :text1="textFile1"
                    :text2="textFile2"
                    :disabled="getIsDisabled"
                    :singleFile="true"
                    :previewImg="true"
                    :singleFileData="singleFileData2"
                    :urlSingleFileData="urlSingleFileData2"
                    :showSingleFile="!receiveData"
                    @removeSingleFile="removeSingleFile2"
                    v-if="form.action2.selected === 1"
                ></FormFilePP>

                <b-form-group label="Link" label-for="linkAction2" v-if="form.action2.selected === 2">
                    <b-form-input
                        name="linkAction2"
                        v-model="form.linkAction2"
                        placeholder="Link aqui"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['acao2_url'].value)
                        "
                    ></b-form-input>
                </b-form-group>

                <div
                    v-if="
                        !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['acao2_url'].value)
                    "
                >
                    <iframe
                        width="100%"
                        height="315"
                        :src="convertYoutubeLink(form.linkAction2)"
                        v-if="
                            form.action2.selected === 2 && form.linkAction2 !== null && isYoutubeLink(form.linkAction2)
                        "
                    ></iframe>
                </div>

                <b-form-group label="Descrição da ação" label-for="descriptionAction2">
                    <b-form-input
                        name="descriptionAction2"
                        v-model="form.descriptionAction2"
                        placeholder="Descreva aqui"
                        :disabled="getIsDisabled"
                    ></b-form-input>
                </b-form-group>

                <b-form-group label="Ação 3" label-for="action3">
                    <b-form-select
                        id="action3"
                        name="action3"
                        v-model="form.action3.selected"
                        :options="form.action3.options"
                        :disabled="getIsDisabled"
                    ></b-form-select>

                    <LockPP
                        :statusLock="form.action3Lock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.action3Lock = Number(!form.action3Lock)"
                        v-if="showLock"
                    />
                </b-form-group>

                <FormFilePP
                    ref="action3Ref"
                    :text1="textFile1"
                    :text2="textFile2"
                    :disabled="getIsDisabled"
                    :singleFile="true"
                    :previewImg="true"
                    :singleFileData="singleFileData3"
                    :urlSingleFileData="urlSingleFileData3"
                    :showSingleFile="!receiveData"
                    @removeSingleFile="removeSingleFile3"
                    v-if="form.action3.selected === 1"
                />

                <b-form-group label="Link" label-for="linkAction3" v-if="form.action3.selected === 2">
                    <b-form-input
                        name="linkAction3"
                        v-model="form.linkAction3"
                        placeholder="Link aqui"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['acao3_url'].value)
                        "
                    ></b-form-input>
                </b-form-group>

                <div
                    v-if="
                        !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['acao3_url'].value)
                    "
                >
                    <iframe
                        width="100%"
                        height="315"
                        :src="convertYoutubeLink(form.linkAction3)"
                        v-if="
                            form.action3.selected === 2 && form.linkAction3 !== null && isYoutubeLink(form.linkAction3)
                        "
                    ></iframe>
                </div>

                <b-form-group label="Descrição da ação" label-for="descriptionAction3">
                    <b-form-input
                        name="descriptionAction3"
                        v-model="form.descriptionAction3"
                        placeholder="Descreva aqui"
                        :disabled="getIsDisabled"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Quais foram seus principais resultados alcançados e impacto gerado?"
                    label-for="resultsImpacts"
                >
                    <b-form-textarea
                        id="resultsImpacts"
                        name="resultsImpacts"
                        v-model="form.resultsImpacts"
                        placeholder="Descreva aqui."
                        rows="6"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform &&
                                    getAuthorizationData &&
                                    getAuthorizationData['principais_resultados'].value)
                        "
                    ></b-form-textarea>

                    <NoAuthorizationMsgPP
                        v-if="
                            isPlatform && getAuthorizationData && !getAuthorizationData['principais_resultados'].value
                        "
                    />
                </b-form-group>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'NetworksPartnersForm1' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('NetworksPartnersForm1')"
                        >Voltar</b-button
                    >

                    <b-button :variant="'primary'" @click="changeRegisterForm('GovernanceForm1')" v-if="abbleNextPage">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="$router.push({ name: 'LoginForm' })">{{
                    $CONTINUAR_PLATAFORMA
                }}</b-button>
                <b-button variant="secondary" @click="nextPage()">Continuar cadastro</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LockPP from '@/ui/lock-pp/LockPP'
import FormFilePP from '@/ui/form-file-pp/FormFilePP'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { ResultsImpactsApi } from '../../api/results-impacts'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const resultsImpactsApi = new ResultsImpactsApi()

export default {
    components: { LockPP, FormFilePP, WarningMsgModal, DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        abbleNextPage: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            progress: 69.25,
            isUpdate: false,
            financialSustainability: null,
            isDisabled: null,
            authorizationData: null,
            textFile1: 'Tamanho de upload de imagem para 2 Mb',
            textFile2: 'Arquivos suportados: .png. e .jpg',
            message: null,
            form: {
                hasMonitoringProcess: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                hasPerformanceIndications: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                indicatorsList: null,
                directly: null,
                indirectly: null,
                action1: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                action1Lock: 1,
                action1Selected: null,
                linkAction1: null,
                singleFileData1: null,
                urlSingleFileData1: null,
                descriptionAction1: null,
                action2: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                action2Lock: 1,
                action2Selected: null,
                linkAction2: null,
                singleFileData2: null,
                urlSingleFileData2: null,
                descriptionAction2: null,
                action3: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                action3Lock: 1,
                action3Selected: null,
                linkAction3: null,
                singleFileData3: null,
                urlSingleFileData3: null,
                descriptionAction3: null,
                resultsImpacts: null
            }
        }
    },
    validations: {
        form: {
            hasMonitoringProcess: {
                selected: { required }
            },
            hasPerformanceIndications: {
                selected: { required }
            },
            directly: { required },
            indirectly: { required }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getAuthorizationData() {
            return this.authorizationData
        },
        getAction1() {
            return this.form.action1.selected
        },
        getAction2() {
            return this.form.action2.selected
        },
        getAction3() {
            return this.form.action3.selected
        }
    },
    watch: {
        getAction1(val) {
            if (this.form.action1Selected !== val) {
                this.form.action1Selected = val
                this.singleFileData1 = null
                this.urlSingleFileData1 = null
                this.form.linkAction1 = null
            }
        },
        getAction2(val) {
            if (this.form.action2Selected !== val) {
                this.form.action2Selected = val
                this.singleFileData2 = null
                this.urlSingleFileData2 = null
                this.form.linkAction2 = null
            }
        },
        getAction3(val) {
            if (this.form.action3Selected !== val) {
                this.form.action3Selected = val
                this.singleFileData3 = null
                this.urlSingleFileData3 = null
                this.form.linkAction3 = null
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData

            this.form.hasMonitoringProcess.selected = data.processo_monitoramento
            this.form.hasPerformanceIndications.selected = data.indicadores_desempenho
            this.form.indicatorsList = data.indicadores_impacto
            this.form.directly = data.pessoas_impactadas_dir
            this.form.indirectly = data.pessoas_impactadas_ind
            this.form.resultsImpacts = data.principais_resultados
            this.form.descriptionAction1 = data.acao1_descricao
            this.form.descriptionAction2 = data.acao2_descricao
            this.form.descriptionAction3 = data.acao3_descricao
            this.form.action1.selected = data.tipo_acao1
            this.form.action2.selected = data.tipo_acao2
            this.form.action3.selected = data.tipo_acao3
            this.form.linkAction1 = data.acao1_url
            this.form.linkAction2 = data.acao2_url
            this.form.linkAction3 = data.acao3_url
            this.form.action1Lock = data.view_acao1
            this.form.action2Lock = data.view_acao2
            this.form.action3Lock = data.view_acao3
            this.form.action1Selected = data.tipo_acao1
            this.form.action2Selected = data.tipo_acao2
            this.form.action3Selected = data.tipo_acao3

            this.loadingFiles(data)
            this.setIsLoading(true)

            axios
                .all([resultsImpactsApi.getActionType()])
                .then(response => {
                    const newActionTypeOptions = response[0].data

                    this.form.action1.options.push(
                        ...newActionTypeOptions.map(item => ({ value: item.id, text: item.tipo }))
                    )

                    this.form.action2.options.push(
                        ...newActionTypeOptions.map(item => ({ value: item.id, text: item.tipo }))
                    )

                    this.form.action3.options.push(
                        ...newActionTypeOptions.map(item => ({ value: item.id, text: item.tipo }))
                    )

                    this.filterData()
                    this.fetchAuthorization()
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        fetch() {
            this.usuario = JSON.parse(localStorage.getItem('usuario'))
            this.setIsLoading(true)

            axios
                .all([resultsImpactsApi.getResultsImpacts(), resultsImpactsApi.getActionType()])
                .then(response => {
                    const data = response[0].data.data
                    const newActionTypeOptions = response[1].data

                    if (data !== null) {
                        this.financialSustainability = data
                        this.form.hasMonitoringProcess.selected = data.processo_monitoramento
                        this.form.hasPerformanceIndications.selected = data.indicadores_desempenho
                        this.form.indicatorsList = data.indicadores_impacto
                        this.form.directly = data.pessoas_impactadas_dir
                        this.form.indirectly = data.pessoas_impactadas_ind
                        this.form.resultsImpacts = data.principais_resultados
                        this.form.descriptionAction1 = data.acao1_descricao
                        this.form.descriptionAction2 = data.acao2_descricao
                        this.form.descriptionAction3 = data.acao3_descricao
                        this.form.action1.selected = data.tipo_acao1
                        this.form.action2.selected = data.tipo_acao2
                        this.form.action3.selected = data.tipo_acao3
                        this.form.linkAction1 = data.acao1_url
                        this.form.linkAction2 = data.acao2_url
                        this.form.linkAction3 = data.acao3_url
                        this.form.action1Lock = data.view_acao1
                        this.form.action2Lock = data.view_acao2
                        this.form.action3Lock = data.view_acao3
                        this.form.action1Selected = data.tipo_acao1
                        this.form.action2Selected = data.tipo_acao2
                        this.form.action3Selected = data.tipo_acao3
                        this.setProgress(data.percentual)

                        this.loadingFiles(data)
                    }

                    this.form.action1.options.push(
                        ...newActionTypeOptions.map(item => ({ value: item.id, text: item.tipo }))
                    )

                    this.form.action2.options.push(
                        ...newActionTypeOptions.map(item => ({ value: item.id, text: item.tipo }))
                    )

                    this.form.action3.options.push(
                        ...newActionTypeOptions.map(item => ({ value: item.id, text: item.tipo }))
                    )
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress

            const data = {
                ...this.financialSustainability,
                processo_monitoramento: this.form.hasMonitoringProcess.selected,
                indicadores_desempenho: this.form.hasPerformanceIndications.selected,
                indicadores_impacto: this.form.indicatorsList,
                pessoas_impactadas_dir: this.form.directly,
                pessoas_impactadas_ind: this.form.indirectly,
                principais_resultados: this.form.resultsImpacts,
                acao1_descricao: this.form.descriptionAction1,
                acao2_descricao: this.form.descriptionAction2,
                acao3_descricao: this.form.descriptionAction3,
                tipo_acao1: this.form.action1.selected,
                tipo_acao2: this.form.action2.selected,
                tipo_acao3: this.form.action3.selected,
                view_acao1: this.form.action1Lock,
                view_acao2: this.form.action2Lock,
                view_acao3: this.form.action3Lock,
                percentual: currentProgress
            }

            if (this.$refs.action1Ref && this.$refs.action1Ref.image) {
                data.acao1_url = this.$refs.action1Ref ? this.$refs.action1Ref.image : null
            } else {
                data.acao1_url = this.form.linkAction1 || null
            }

            if (this.$refs.action2Ref && this.$refs.action2Ref.image) {
                data.acao2_url = this.$refs.action2Ref ? this.$refs.action2Ref.image : null
            } else {
                data.acao2_url = this.form.linkAction2 || null
            }

            if (this.$refs.action3Ref && this.$refs.action3Ref.image) {
                data.acao3_url = this.$refs.action3Ref ? this.$refs.action3Ref.image : null
            } else {
                data.acao3_url = this.form.linkAction3 || null
            }

            this.setIsLoading(true)
            const request = this.isUpdate
                ? resultsImpactsApi.updateResultsImpacts(data)
                : resultsImpactsApi.createResultsImpacts(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.message = response.data.message
                    this.isUpdate ? this.changeStatusDisabled(true) : this.showModal('warning-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        loadingFiles(data) {
            if (this.form.action1.selected === 1 && data.acao1_url) {
                this.singleFileData1 = {
                    name: data.acao1_url.split('.')[0],
                    type: data.acao1_url.split('.')[1]
                }

                this.urlSingleFileData1 = this.$PPP_URL_FILE + data.acao1_url
            }

            if (this.form.action2.selected === 1 && data.acao2_url) {
                this.singleFileData2 = {
                    name: data.acao2_url.split('.')[0],
                    type: data.acao2_url.split('.')[1]
                }

                this.urlSingleFileData2 = this.$PPP_URL_FILE + data.acao2_url
            }

            if (this.form.action3.selected === 1 && data.acao3_url) {
                this.singleFileData3 = {
                    name: data.acao3_url.split('.')[0],
                    type: data.acao3_url.split('.')[1]
                }

                this.urlSingleFileData3 = this.$PPP_URL_FILE + data.acao3_url
            }
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        nextPage() {
            this.hideModal('warning-modal-ref')
            this.$router.push({ name: 'GovernanceForm1' })
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getResultsImpacts(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        convertYoutubeLink(link) {
            if (link === null) {
                return link
            }

            let newLink = ''
            newLink = link.split('&ab_channel')[0]
            newLink = newLink.replace('watch?v=', 'embed/')
            return newLink
        },
        removeSingleFile1() {
            this.form.urlSingleFileData1 = null
            this.form.linkAction1 = null
        },
        removeSingleFile2() {
            this.form.urlSingleFileData2 = null
            this.form.linkAction2 = null
        },
        removeSingleFile3() {
            this.form.urlSingleFileData3 = null
            this.form.linkAction3 = null
        },
        isYoutubeLink(link) {
            return link.includes('www.youtube.com')
        },
        filterData() {
            if (this.receiveData) {
                this.form.hasMonitoringProcess.options = this.form.hasMonitoringProcess.options.filter(
                    x => Number(this.form.hasMonitoringProcess.selected) === x.value
                )

                this.form.hasPerformanceIndications.options = this.form.hasPerformanceIndications.options.filter(
                    x => Number(this.form.hasPerformanceIndications.selected) === x.value
                )
            }
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./ResultsImpactsForm1-light-theme.css"></style>
<style scope src="./ResultsImpactsForm1-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-results-impacts-forms/ResultsImpactsForm1.vue